import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useAuthStore, useCurrentPageStore } from "../stores/store";
import { AuthenStoreType } from "../types/authen";
import { InitialUserPageType } from "../types/global";

interface AuthenticationProps {
  children: ReactNode;
}

const Authentication = ({ children }: AuthenticationProps) => {
  const navigate = useNavigate();
  const { user: auth, clearAuthState: clearAuth } = useAuthStore(
    (state) => state as AuthenStoreType,
  );
  const { clearCurrentPageState } = useCurrentPageStore(
    (state) => state as InitialUserPageType,
  );

  useEffect(() => {
    const checkAuth = () => {
      if (!auth) {
        clearAuth();
        clearCurrentPageState();
        navigate("/", { replace: true });
      }
    };

    // Only run the check once auth state is available
    if (auth !== undefined) {
      checkAuth();
    }
  }, [auth, navigate, clearAuth]);

  // If the state is still loading (or the user is unauthorized), show nothing or a loading spinner
  if (!auth) return null;

  return <>{children}</>;
};

export default Authentication;
